import { useCallback, useEffect, useState } from "react";

import { parse, serialize } from "cookie";

import { currentConfig } from "@ala/core/constants";

const tenantCookieName = "Current-Tenant-Id";
const tenantCookieAge = 60 * 60 * 24 * 365;

export const useTenantCookie = () => {
  const [tenantCookie, setTenantCookie] = useState<string | null>(null);

  useEffect(() => {
    const cookies = parse(document.cookie);

    if (cookies[tenantCookieName]) {
      setTenantCookie(cookies[tenantCookieName]);
    }
  }, []);

  const updateTenantCookie = useCallback((tenantId: string) => {
    document.cookie = serialize(tenantCookieName, tenantId, {
      maxAge: tenantCookieAge,
      domain: currentConfig.domain,
      path: "/",
    });
    setTenantCookie(tenantId);
  }, []);

  const clearTenantCookie = useCallback(() => {
    document.cookie = serialize(tenantCookieName, "", {
      expires: new Date(0),
      domain: currentConfig.domain,
      path: "/",
    });
  }, []);

  return { tenantCookie, updateTenantCookie, clearTenantCookie };
};
